// --------------------------------------------------------------
// Created On: 2023-01-27
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";

// A single report in a list of reports.
export default function ReportListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="report-list-row">
      <span>{props.name}</span>
    </div>
  );
}

interface Props {
  reportId: number;
  name: string;
}
